import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

import { StringsEN } from '../../constants/language-strings/strings-en';
import { StringsES } from '../../constants/language-strings/strings-es';
import { StringsDE } from '../../constants/language-strings/strings-de';


@Injectable({
  providedIn: 'root'
})
export class LanguageService {

  public availableLanguages = [
    {languageCode: 'en', languageString: 'EN', languageFlag: 'assets/countries/EN_Flag.png'},
    {languageCode: 'es', languageString: 'ES', languageFlag: 'assets/countries/ES_Flag.png'},
    //{languageCode: 'de', languageString: 'DE', languageFlag: 'assets/countries/DE_Flag.png'},
  ]

  public Strings:any = {}
  public languageCode:string = 'en'
  public languageString:string = 'EN'
  public languageFlag:string = 'assets/countries/EN_Flag.png'

  public languageCodeObservable: BehaviorSubject<string> = new BehaviorSubject<string>('en');

  constructor() { }


  setLanguage(language:string){
    if(language == 'es'){
      // Spanish
      this.Strings =  StringsES
      this.languageCode = 'es'
      this.languageCodeObservable.next('es')
      this.languageString = 'ES'
      this.languageFlag = 'assets/countries/ES_Flag.png'
    }else if(language == 'de'){
      // Spanish
      this.Strings =  StringsDE
      this.languageCode = 'de'
      this.languageCodeObservable.next('de')
      this.languageString = 'DE'
      this.languageFlag = 'assets/countries/DE_Flag.png'
    }else{
      // English (default)
      this.Strings = StringsEN
      this.languageCode = 'en'
      this.languageCodeObservable.next('en')
      this.languageString = 'EN'
      this.languageFlag = 'assets/countries/EN_Flag.png'
    }
  }


  setLanguageAccordingToNavigatorLanguage(){
    let navigatorLanguage = navigator.language
    if(navigatorLanguage.includes('es')){
      this.setLanguage('es')
    }else if(navigatorLanguage.includes('de')){
      this.setLanguage('de')
    }else{
      this.setLanguage('en')
    }
  }



  getCurrentLanguageCode(): Observable<string> {
    return this.languageCodeObservable.asObservable();
  }


  updateLanguageFromHeaderButton() {
    // Get current language index
    const currentLanguageIndex = this.availableLanguages.findIndex(lang => lang.languageCode === this.languageCode);
    // Get next index (looping)
    let nextLanguageIndex: number;
    if (currentLanguageIndex === -1 || currentLanguageIndex === this.availableLanguages.length - 1) {
      nextLanguageIndex = 0;
    } else {
      nextLanguageIndex = currentLanguageIndex + 1;
    }
    // Get corresponding language code
    const newLanguageCode = this.availableLanguages[nextLanguageIndex].languageCode;
    // Update the language code
    this.setLanguage(newLanguageCode);
  }

}
